import { getBrowserGuid } from '../browser_guid.js';
import { trackEvent } from '../../../utils/analytics/analytics.js';
import { paramOrNul, getClientPlatform } from '../../../../common/config/utils.js';

const partnerKey = 'powl_pid';

export const getReturnedFromNextStep = (currentStep) => {
  const state = window.store.getState();
  const maxStep = state?.wizard?.maxStep ?? 0;
  return currentStep < maxStep;
};

const getPowebStatus = (state) => {
  const purchaseType = state?.purchaseDetails?.purchaseType;
  const ccToken = state?.payment?.paymentsCardData?.cardData?.token;
  const email = state?.order?.pendingWebOrder?.email;
  const nickname = state?.order?.pendingWebOrder?.nickname;
  const gender = state?.order?.pendingWebOrder?.gender;
  const dateOfBirth = state?.order?.pendingWebOrder?.dateOfBirth;

  let status = '';

  switch (true) {
    case !!(purchaseType):
      status = 'purchase completed';
      break;
    case !!(ccToken):
      status = 'credit card added';
      break;
    case !!(email):
      status = 'email added';
      break;
    case !!(nickname && gender && dateOfBirth):
      status = 'personal details added';
      break;
    default:
      status = 'anonymous';
  }

  return status;
};

export const getOnboardingEventProperties = () => {
  const state = window.store.getState();
  const userId = state?.user?.user?.userId;
  const gender = state?.user?.user?.gender;
  const advisorId = state?.order?.pendingWebOrder?.advisor?.id;
  const email = state?.order?.pendingWebOrder?.email;
  const orderId = state?.order?.pendingWebOrder?.orderId;
  const paymentGateway = state?.payment?.paymentsResponce?.gatewayName;

  return ({
    platform: getClientPlatform(),
    'browser guid': getBrowserGuid(),
    'poweb status': getPowebStatus(state),
    'wizard variation name': window.config.showIntroPage ? 'with intro' : 'no intro',
    ...paramOrNul('user id', userId),
    ...paramOrNul('gender', gender),
    ...paramOrNul('advisor id', advisorId),
    ...paramOrNul('email address', email),
    ...paramOrNul('order id', orderId),
    ...paramOrNul('payment gateway', paymentGateway),
    ...paramOrNul('white label partner', window.attribution[partnerKey]),
    ...window?.attribution?.mixpanel
  });
};

export const trackOnboardingEvent = (name, properties) => {
  const commonProps = getOnboardingEventProperties();
  trackEvent(name, {
    ...commonProps,
    ...properties
  });
};

export const getZodiacSign = (dateOfBirth) => {
  const signDays = [22, 20, 21, 21, 22, 23, 23, 23, 23, 23, 22, 22];
  const zodiacSigns = ['capricorn', 'aquarius', 'pisces', 'aries', 'taurus', 'gemini', 'cancer', 'leo', 'virgo', 'libra', 'scorpio', 'sagittarius', 'capricorn'];
  if (new Date(dateOfBirth).getDate() < signDays[new Date(dateOfBirth).getMonth()]) {
    return zodiacSigns[new Date(dateOfBirth).getMonth()];
  }
  return zodiacSigns[new Date(dateOfBirth).getMonth() + 1];
};

export const getUserZodiacSign = () => {
  const state = window.store.getState();
  const dateOfBirth = state?.user?.user?.dateOfBirth;
  if (dateOfBirth) {
    return getZodiacSign(dateOfBirth);
  }
  return null;
};
